<template>
  <div id="erro">
    <vue-headful :title="$store.state.option['404_title-' + lang]" :lang="lang" />
    <titulo></titulo>

    <div class="container p-v-60">
      <div class="text-center g-flex-centered-item g-position-rel g-pb-15">
        <div class="g-font-size-180 g-font-size-240--sm g-line-height-1 g-font-weight-600er g-color-gray-light-v4">{{$store.state.option['404_text1-' + lang]}}</div>
        <div class="clearfix"></div>

        <div class="g-absolute-centered text-center">
          <hr class="g-brd-gray-light-v3 g-my-15">
          <p class="g-font-size-18 mb-0"><router-link to="/" exact class="g-color-black g-color-primary--hover g-text-no-underline--hover">← {{$store.state.option['404_home-' + lang]}}</router-link>
          </p>
        </div>
      </div>
    </div>

    <pesquisa></pesquisa>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import titulo from '@/components/titulo'
import pesquisa from '@/components/pesquisa'

export default {
  components: { titulo, pesquisa },
  data () {
    return {
      lang: ''
    }
  },
  watch: {
    '$route' (b, c) {
      this.SET_LOAD(true)
      this.init()
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_LOAD',
      'SET_TITULO',
      'SET_SUBTITULO'
    ]),
    init () {
      if (this.$store.state.option1 && this.$store.state.stations1) {
        this.SET_TITULO(this.$store.state.option['404_title-' + this.lang])
        this.SET_SUBTITULO(this.$store.state.option['404_subtitle-' + this.lang])
        this.lang = this.$store.state.lang
        this.SET_LOAD()
      } else {
        this._.delay(this.init, 100)
      }
    }
  }
}
</script>

<style type="text/css" media="screen">
@media (min-width: 0)
.g-pa-15 {
    padding: 1.07143rem !important;
}
.g-min-height-100vh {
    min-height: 100vh;
}
.g-flex-centered {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

@media (min-width: 0)
.g-pb-15 {
    padding-bottom: 1.07143rem !important;
}
.g-flex-centered-item {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
}

.g-color-gray-light-v4 {
    color: #eee !important;
}
.g-line-height-1 {
    line-height: 1 !important;
}
@media (min-width: 576px)
.g-font-size-240--sm {
    font-size: 17.14286rem !important;
}
.g-font-size-180 {
    font-size: 12.85714rem !important;
}
*, ::after, ::before {
    box-sizing: border-box;
}
user agent stylesheet
div {
    display: block;
}
.g-absolute-centered {
  display:inline-block;
  margin: 0 auto;
}
</style>
